import { Grid } from '@mui/material'
import { useLayout } from 'context'
import * as controllers from 'controllers'
import {
  VehicleCheckInAirbagTellTalePhotoDto,
  VehicleCheckInBackupCamPhotoDto,
  VehicleCheckInCheckInClusterPhotoDto,
  VehicleCheckInClusterWithOdometerPhotoDto,
  VehicleCheckInComboPhotoDto,
  VehicleCheckInDetailsDto,
  VehicleCheckInDriverAirbagPhotoDto,
  VehicleCheckInFrontCornerPhotoDto,
  VehicleCheckInFrontHeadOnPhotoDto,
  VehicleCheckInImporterDoorLabelPhotoDto,
  VehicleCheckInManufacturersLabelPhotoDto,
  VehicleCheckInPassengerAirbagPhotoDto,
  VehicleCheckInRearCornerPhotoDto,
  VehicleCheckInRearHeadOnPhotoDto,
  VehicleCheckInRoofPhotoDto,
  VehicleCheckInTirePressureLabelPhotoDto,
  VehicleCheckInVINOnDashboardPhotoDto
} from 'dtos'
import { enqueueSnackbar } from 'notistack'
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { formatDateTime } from 'utils'
import Step1VehicleDetails from './Step1VehicleDetails'
import Step2PrintLabels from './Step2PrintLabels'
import Step3CheckInPhotos from './Step3CheckInPhotos'
import Step4CheckInReview from './Step4CheckInReview'
import VehicleCheckInHeroCard from './VehicleCheckInHeroCard'

export interface VehicleCheckInPhotosProps {
  manufacturersLabelPhoto: VehicleCheckInManufacturersLabelPhotoDto
  setManufacturersLabelPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInManufacturersLabelPhotoDto>>
  tirePressureLabelPhoto: VehicleCheckInTirePressureLabelPhotoDto
  setTirePressureLabelPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInTirePressureLabelPhotoDto>>
  importerDoorLabelPhoto: VehicleCheckInImporterDoorLabelPhotoDto
  setImporterDoorLabelPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInImporterDoorLabelPhotoDto>>
  comboPhoto: VehicleCheckInComboPhotoDto
  setComboPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInComboPhotoDto>>
  checkInClusterPhoto: VehicleCheckInCheckInClusterPhotoDto
  setCheckInClusterPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInCheckInClusterPhotoDto>>
  clusterWithOdometerPhoto: VehicleCheckInClusterWithOdometerPhotoDto
  setClusterWithOdometerPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInClusterWithOdometerPhotoDto>>
  driverAirbagPhoto: VehicleCheckInDriverAirbagPhotoDto
  setDriverAirbagPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInDriverAirbagPhotoDto>>
  backupCamPhoto: VehicleCheckInBackupCamPhotoDto
  setBackupCamPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInBackupCamPhotoDto>>
  airbagTellTalePhoto: VehicleCheckInAirbagTellTalePhotoDto
  setAirbagTellTalePhoto: React.Dispatch<React.SetStateAction<VehicleCheckInAirbagTellTalePhotoDto>>
  passengerAirbagPhoto: VehicleCheckInPassengerAirbagPhotoDto
  setPassengerAirbagPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInPassengerAirbagPhotoDto>>
  vinOnDashboardPhoto: VehicleCheckInVINOnDashboardPhotoDto
  setVinOnDashboardPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInVINOnDashboardPhotoDto>>
  roofPhoto: VehicleCheckInRoofPhotoDto
  setRoofPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInRoofPhotoDto>>
  frontCornerPhoto: VehicleCheckInFrontCornerPhotoDto
  setFrontCornerPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInFrontCornerPhotoDto>>
  frontHeadOnPhoto: VehicleCheckInFrontHeadOnPhotoDto
  setFrontHeadOnPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInFrontHeadOnPhotoDto>>
  rearCornerPhoto: VehicleCheckInRearCornerPhotoDto
  setRearCornerPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInRearCornerPhotoDto>>
  rearHeadOnPhoto: VehicleCheckInRearHeadOnPhotoDto
  setRearHeadOnPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInRearHeadOnPhotoDto>>
}

export default function VehicleCheckIn() {
  const { vehicleGuid } = useParams()
  const layout = useLayout()
  const navigate = useNavigate()

  const [initialValues, setInitialValues] = useState<VehicleCheckInDetailsDto>(new VehicleCheckInDetailsDto())
  const [activeStep, setActiveStep] = useState<number>(0)
  const [manufacturersLabelPhoto, setManufacturersLabelPhoto] = useState<VehicleCheckInManufacturersLabelPhotoDto>(
    new VehicleCheckInManufacturersLabelPhotoDto()
  )
  const [tirePressureLabelPhoto, setTirePressureLabelPhoto] = useState<VehicleCheckInTirePressureLabelPhotoDto>(new VehicleCheckInTirePressureLabelPhotoDto())
  const [importerDoorLabelPhoto, setImporterDoorLabelPhoto] = useState<VehicleCheckInImporterDoorLabelPhotoDto>(new VehicleCheckInImporterDoorLabelPhotoDto())
  const [comboPhoto, setComboPhoto] = useState<VehicleCheckInComboPhotoDto>(new VehicleCheckInComboPhotoDto())
  const [checkInClusterPhoto, setCheckInClusterPhoto] = useState<VehicleCheckInCheckInClusterPhotoDto>(new VehicleCheckInCheckInClusterPhotoDto())
  const [clusterWithOdometerPhoto, setClusterWithOdometerPhoto] = useState<VehicleCheckInClusterWithOdometerPhotoDto>(
    new VehicleCheckInClusterWithOdometerPhotoDto()
  )
  const [driverAirbagPhoto, setDriverAirbagPhoto] = useState<VehicleCheckInDriverAirbagPhotoDto>(new VehicleCheckInDriverAirbagPhotoDto())
  const [backupCamPhoto, setBackupCamPhoto] = useState<VehicleCheckInBackupCamPhotoDto>(new VehicleCheckInBackupCamPhotoDto())
  const [airbagTellTalePhoto, setAirbagTellTalePhoto] = useState<VehicleCheckInAirbagTellTalePhotoDto>(new VehicleCheckInAirbagTellTalePhotoDto())
  const [passengerAirbagPhoto, setPassengerAirbagPhoto] = useState<VehicleCheckInPassengerAirbagPhotoDto>(new VehicleCheckInPassengerAirbagPhotoDto())
  const [vinOnDashboardPhoto, setVinOnDashboardPhoto] = useState<VehicleCheckInVINOnDashboardPhotoDto>(new VehicleCheckInVINOnDashboardPhotoDto())
  const [roofPhoto, setRoofPhoto] = useState<VehicleCheckInRoofPhotoDto>(new VehicleCheckInRoofPhotoDto())
  const [frontCornerPhoto, setFrontCornerPhoto] = useState<VehicleCheckInFrontCornerPhotoDto>(new VehicleCheckInFrontCornerPhotoDto())
  const [frontHeadOnPhoto, setFrontHeadOnPhoto] = useState<VehicleCheckInFrontHeadOnPhotoDto>(new VehicleCheckInFrontHeadOnPhotoDto())
  const [rearCornerPhoto, setRearCornerPhoto] = useState<VehicleCheckInRearCornerPhotoDto>(new VehicleCheckInRearCornerPhotoDto())
  const [rearHeadOnPhoto, setRearHeadOnPhoto] = useState<VehicleCheckInRearHeadOnPhotoDto>(new VehicleCheckInRearHeadOnPhotoDto())

  const checkInPhotosRequestedRef = useRef(false)

  useEffect(() => {
    if (vehicleGuid) {
      layout.setIsLayoutLoading(true)
      controllers
        .getVehicleCheckInDetails(vehicleGuid)
        .then(response => {
          console.log('Vehicle Check In Details:', response.value)
          setInitialValues(response.value)
        })
        .finally(() => {
          layout.setIsLayoutLoading(false)
        })
    }
  }, [vehicleGuid])

  useEffect(() => {
    if (!vehicleGuid || activeStep < 2 || checkInPhotosRequestedRef.current) {
      return
    }
    checkInPhotosRequestedRef.current = true

    controllers.getVehicleCheckInManufacturersLabelPhotoInformation(vehicleGuid).then(response => {
      setManufacturersLabelPhoto(response.value)
    })

    controllers.getVehicleCheckInTirePressureLabelPhotoInformation(vehicleGuid).then(response => {
      setTirePressureLabelPhoto(response.value)
    })

    controllers.getVehicleCheckInImporterDoorLabelPhotoInformation(vehicleGuid).then(response => {
      setImporterDoorLabelPhoto(response.value)
    })

    controllers.getVehicleCheckInComboPhotoInformation(vehicleGuid).then(response => {
      setComboPhoto(response.value)
    })

    controllers.getVehicleCheckInCheckInClusterPhotoInformation(vehicleGuid).then(response => {
      setCheckInClusterPhoto(response.value)
    })

    controllers.getVehicleCheckInClusterWithOdometerPhotoInformation(vehicleGuid).then(response => {
      setClusterWithOdometerPhoto(response.value)
    })

    controllers.getVehicleCheckInDriverAirbagPhotoInformation(vehicleGuid).then(response => {
      setDriverAirbagPhoto(response.value)
    })

    controllers.getVehicleCheckInBackupCamPhotoInformation(vehicleGuid).then(response => {
      setBackupCamPhoto(response.value)
    })

    controllers.getVehicleCheckInAirbagTellTalePhotoInformation(vehicleGuid).then(response => {
      setAirbagTellTalePhoto(response.value)
    })

    controllers.getVehicleCheckInPassengerAirbagPhotoInformation(vehicleGuid).then(response => {
      setPassengerAirbagPhoto(response.value)
    })

    controllers.getVehicleCheckInVINOnDashboardPhotoInformation(vehicleGuid).then(response => {
      setVinOnDashboardPhoto(response.value)
    })

    controllers.getVehicleCheckInRoofPhotoInformation(vehicleGuid).then(response => {
      setRoofPhoto(response.value)
    })

    controllers.getVehicleCheckInFrontCornerPhotoInformation(vehicleGuid).then(response => {
      setFrontCornerPhoto(response.value)
    })

    controllers.getVehicleCheckInFrontHeadOnPhotoInformation(vehicleGuid).then(response => {
      setFrontHeadOnPhoto(response.value)
    })

    controllers.getVehicleCheckInRearCornerPhotoInformation(vehicleGuid).then(response => {
      setRearCornerPhoto(response.value)
    })

    controllers.getVehicleCheckInRearHeadOnPhotoInformation(vehicleGuid).then(response => {
      setRearHeadOnPhoto(response.value)
    })
  }, [vehicleGuid, activeStep])

  const onBack = () => {
    setActiveStep(prev => Math.max(0, prev - 1))
  }

  const onNext = () => {
    setActiveStep(prev => Math.min(3, prev + 1))
  }

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <VehicleCheckInHeroCard vehicle={initialValues} />
      </Grid>

      {activeStep === 0 && (
        <Grid item xs={12}>
          <Step1VehicleDetails
            initialValues={initialValues}
            onNext={values => {
              layout.setIsLayoutLoading(true)
              controllers
                .updateVehicleCheckInDetails(vehicleGuid!, values)
                .then(response => {
                  enqueueSnackbar('Vehicle Details Saved Successfully!', { variant: 'success' })
                  setInitialValues(response.value)
                  onNext()
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
          />
        </Grid>
      )}

      {activeStep === 1 && (
        <Grid item xs={12}>
          <Step2PrintLabels onBack={onBack} onNext={onNext} vehicleCheckInDetails={initialValues} vehicleGuid={vehicleGuid} />
        </Grid>
      )}

      {activeStep === 2 && (
        <Grid item xs={12}>
          <Step3CheckInPhotos
            onBack={onBack}
            onNext={onNext}
            vehicleCheckInDetails={initialValues}
            vehicleGuid={vehicleGuid}
            manufacturersLabelPhoto={manufacturersLabelPhoto}
            setManufacturersLabelPhoto={setManufacturersLabelPhoto}
            tirePressureLabelPhoto={tirePressureLabelPhoto}
            setTirePressureLabelPhoto={setTirePressureLabelPhoto}
            importerDoorLabelPhoto={importerDoorLabelPhoto}
            setImporterDoorLabelPhoto={setImporterDoorLabelPhoto}
            comboPhoto={comboPhoto}
            setComboPhoto={setComboPhoto}
            checkInClusterPhoto={checkInClusterPhoto}
            setCheckInClusterPhoto={setCheckInClusterPhoto}
            clusterWithOdometerPhoto={clusterWithOdometerPhoto}
            setClusterWithOdometerPhoto={setClusterWithOdometerPhoto}
            driverAirbagPhoto={driverAirbagPhoto}
            setDriverAirbagPhoto={setDriverAirbagPhoto}
            backupCamPhoto={backupCamPhoto}
            setBackupCamPhoto={setBackupCamPhoto}
            airbagTellTalePhoto={airbagTellTalePhoto}
            setAirbagTellTalePhoto={setAirbagTellTalePhoto}
            passengerAirbagPhoto={passengerAirbagPhoto}
            setPassengerAirbagPhoto={setPassengerAirbagPhoto}
            vinOnDashboardPhoto={vinOnDashboardPhoto}
            setVinOnDashboardPhoto={setVinOnDashboardPhoto}
            roofPhoto={roofPhoto}
            setRoofPhoto={setRoofPhoto}
            frontCornerPhoto={frontCornerPhoto}
            setFrontCornerPhoto={setFrontCornerPhoto}
            frontHeadOnPhoto={frontHeadOnPhoto}
            setFrontHeadOnPhoto={setFrontHeadOnPhoto}
            rearCornerPhoto={rearCornerPhoto}
            setRearCornerPhoto={setRearCornerPhoto}
            rearHeadOnPhoto={rearHeadOnPhoto}
            setRearHeadOnPhoto={setRearHeadOnPhoto}
          />
        </Grid>
      )}

      {activeStep === 3 && (
        <Grid item xs={12}>
          <Step4CheckInReview
            onBack={onBack}
            onSubmit={() => {
              layout.setIsLayoutLoading(true)
              controllers
                .updateVehicleCheckInDetails(vehicleGuid!, {
                  ...initialValues,
                  isCheckedIn: true,
                  vehicleCheckInDateTime: formatDateTime(new Date())
                })
                .then(response => {
                  enqueueSnackbar('Vehicle Checked In Successfully!', { variant: 'success' })
                  setInitialValues(response.value)
                  navigate('/to-do-list', { replace: true })
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
            onSubmitAndRecordVehicleDamage={() => {
              layout.setIsLayoutLoading(true)
              controllers
                .updateVehicleCheckInDetails(vehicleGuid!, {
                  ...initialValues,
                  isCheckedIn: true,
                  vehicleCheckInDateTime: formatDateTime(new Date())
                })
                .then(response => {
                  enqueueSnackbar('Vehicle Checked In Successfully!', { variant: 'success' })
                  setInitialValues(response.value)
                  const vin = response.value.vin ?? ''
                  const prefillSearch = vin.length >= 6 ? vin.slice(-6) : vin
                  navigate(`/damage/add-damage/${vehicleGuid!}?autoSearch=1&prefillSearch=${encodeURIComponent(prefillSearch)}`, {
                    replace: true
                  })
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
            vehicleCheckInDetails={initialValues}
            vehicleGuid={vehicleGuid}
            manufacturersLabelPhoto={manufacturersLabelPhoto}
            setManufacturersLabelPhoto={setManufacturersLabelPhoto}
            tirePressureLabelPhoto={tirePressureLabelPhoto}
            setTirePressureLabelPhoto={setTirePressureLabelPhoto}
            importerDoorLabelPhoto={importerDoorLabelPhoto}
            setImporterDoorLabelPhoto={setImporterDoorLabelPhoto}
            comboPhoto={comboPhoto}
            setComboPhoto={setComboPhoto}
            checkInClusterPhoto={checkInClusterPhoto}
            setCheckInClusterPhoto={setCheckInClusterPhoto}
            clusterWithOdometerPhoto={clusterWithOdometerPhoto}
            setClusterWithOdometerPhoto={setClusterWithOdometerPhoto}
            driverAirbagPhoto={driverAirbagPhoto}
            setDriverAirbagPhoto={setDriverAirbagPhoto}
            backupCamPhoto={backupCamPhoto}
            setBackupCamPhoto={setBackupCamPhoto}
            airbagTellTalePhoto={airbagTellTalePhoto}
            setAirbagTellTalePhoto={setAirbagTellTalePhoto}
            passengerAirbagPhoto={passengerAirbagPhoto}
            setPassengerAirbagPhoto={setPassengerAirbagPhoto}
            vinOnDashboardPhoto={vinOnDashboardPhoto}
            setVinOnDashboardPhoto={setVinOnDashboardPhoto}
            roofPhoto={roofPhoto}
            setRoofPhoto={setRoofPhoto}
            frontCornerPhoto={frontCornerPhoto}
            setFrontCornerPhoto={setFrontCornerPhoto}
            frontHeadOnPhoto={frontHeadOnPhoto}
            setFrontHeadOnPhoto={setFrontHeadOnPhoto}
            rearCornerPhoto={rearCornerPhoto}
            setRearCornerPhoto={setRearCornerPhoto}
            rearHeadOnPhoto={rearHeadOnPhoto}
            setRearHeadOnPhoto={setRearHeadOnPhoto}
          />
        </Grid>
      )}
    </Grid>
  )
}
